export default __webpack_public_path__ + "static/media/distance.4676ec1e.svg";